import { AutocompleteCustomValuesParams } from "PFCore/services/autocomplete/fetch_autocomplete_custom_values";
import { CustomValuesLocalisationQueryParams, CustomValuesQueryParams } from "PFCore/services/custom_values";
import { Id } from "PFTypes";

export const customValuesKeys = {
  all: () => ["customValues"],
  list: (params: CustomValuesQueryParams) => [...customValuesKeys.all(), params],
  options: (params: AutocompleteCustomValuesParams) => [...customValuesKeys.all(), params],
  tags: () => [...customValuesKeys.all(), "tags"],
  localisation: () => [...customValuesKeys.all(), "localisation"],
  localisationList: (params: CustomValuesLocalisationQueryParams) => [
    ...customValuesKeys.localisation(),
    params
  ],
  localisationEntry: (id: Id, locales?: string[]) => [...customValuesKeys.localisation(), id, locales]
};
